import React from 'react';
import { copyFor } from 'config';
import { PageHeading } from 'components/page-heading';
import { SolarExplainer } from 'pages/solar/components/solar-explainer';
import { Page, Grid, LeftColumnGridCell } from 'styles';

const getCopy = copyFor('solar');

export const Unavailable = () => {
  return (
    <Page small={{ padding: '0 0 24px' }}>
      <PageHeading page={getCopy('heading')} />
      <Grid width="100%" gap="24px">
        <LeftColumnGridCell>
          <SolarExplainer />
        </LeftColumnGridCell>
      </Grid>
    </Page>
  );
};
